import { render, staticRenderFns } from "./VolunteersSendNotifications.vue?vue&type=template&id=218f7b3b&"
import script from "./VolunteersSendNotifications.vue?vue&type=script&lang=js&"
export * from "./VolunteersSendNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports